import { useLocation, useNavigate } from 'react-router-dom';
import { DatabaseBackup, KeyRound, PackageCheck, Palette, ScrollText, Settings, ShieldCheck, UserCog, Users } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const ADMIN_ITEMS = [
  ['/users', 'User', Users],
  ['/audit-logs', 'Audit', ScrollText],
  ['/system', 'Backup', DatabaseBackup],
  ['/updater', 'Update', PackageCheck],
  ['/branding', 'Branding', Palette],
  ['/license', 'Lisensi', KeyRound],
  ['/monitoring', 'Monitoring', ShieldCheck],
];
const SETTINGS_PATHS = ['/settings', '/users', '/audit-logs', '/system', '/updater', '/branding', '/license', '/monitoring', '/account'];

export const isSettingsPath = (path) => SETTINGS_PATHS.some((item) => path === item || path.startsWith(`${item}/`));

export default function SettingsNav() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const items = [...(user?.role === 'admin' ? ADMIN_ITEMS : []), ['/account', 'Akun Saya', UserCog]];
  return (
    <section className="mb-6">
      <div className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-subtle-fpccs"><Settings className="h-4 w-4" /> Pengaturan</div>
      <nav aria-label="Navigasi pengaturan" className="card-fpccs flex min-h-[54px] max-w-full items-center gap-1 overflow-x-auto overflow-y-hidden overscroll-x-contain p-1.5 [scrollbar-width:thin]">
        {items.map(([path, label, Icon]) => {
          const active = location.pathname === path || location.pathname.startsWith(`${path}/`);
          return <button key={path} type="button" onClick={() => navigate(path)} className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-xl px-3 py-2.5 text-xs font-medium transition ${active ? 'bg-[var(--fpccs-primary)] text-white shadow-[0_6px_18px_rgba(var(--fpccs-primary-rgb),0.24)]' : 'text-muted-fpccs hover:bg-[var(--fpccs-surface-2)] hover:text-[var(--fpccs-text)]'}`}><Icon className="h-4 w-4" />{label}</button>;
        })}
      </nav>
    </section>
  );
}
